var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","data-bs-placement":"top","data-bs-toggle":"tooltip","title":_vm.content}},[_c('i',{staticClass:"bi-info-circle",attrs:{"role":"img","aria-label":"Info"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }